<!-- <h1 mat-dialog-title>Document Viewer</h1> -->
<div mat-dialog-content>
  <div class="doc_top">
    <div class="name d-inline-block"><h4 class="stakeholder_name d-inline-block"> {{selectedDocument.FileName}}</h4></div>
  <div class="right">
    <div class="phone_number d-inline-block" (click)="gobackToDocList()"><mat-icon style="cursor: pointer;">arrow_back</mat-icon> </div>
  <button (click)="$event.stopImmediatePropagation()" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  </div>
  </div>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="downloadSelectedDoc()">
      <mat-icon>dialpad</mat-icon>
      <span>Download</span>
    </button>
    <button mat-menu-item (click)="gobackToDocList()">
      <mat-icon>arrow_back</mat-icon>
      <span>Back to List</span>
    </button>
    <button mat-menu-item disabled>
      <mat-icon>voicemail</mat-icon>
      <span>Classify</span>
    </button>
    <button mat-menu-item>
      <mat-icon>notifications_off</mat-icon>
      <span>Approve</span>
    </button>
    <button mat-menu-item>
      <mat-icon>notifications_off</mat-icon>
      <span>Delete</span>
    </button>
  </mat-menu>
<div *ngIf="showDoc">

  <div style="height: fit-content;">
    <div *ngIf="docType === 'Image'">
      <angular-image-viewer  [src]="images" [(config)]="config" [(index)]="imageIndexOne"
      [screenHeightOccupied]='0'  (customImageEvent)="handleEvent($event)"   >
    </angular-image-viewer>
     </div>

     <div *ngIf="docType === 'pdf' || docType === 'mammoth'">
      <ngx-doc-viewer
      queryParams="hl=Nl"
      [url]="selectedDocument.FilePath"
      [viewer]="docType"
      style="width:100%;height:100vh;"
       ></ngx-doc-viewer>
     </div>

     <div *ngIf="docType === 'video' || docType === 'mammoth'">
      <!-- <video  class="video"  autoplay></video> -->
      <video class="video" autoplay controls>
        <source [src]="selectedDocument.FilePath" type="video/mp4">
        Your browser does not support the video element. Kindly update it to latest version.
      </video >
     </div>

     <div *ngIf="docType === 'Excel'" class="table-responsive" #fullScreen>
      <table id="TheTable" class="table table-bordered table-hover">
        <thead #header class="thead-dark">
          <tr>
            <th *ngFor="let headValue of headData">
              {{headValue}}
            </th>
          </tr>
        </thead>
        <tbody #container>
          <tr *ngFor="let row of data">
            <td *ngFor="let val of headData; let i =index">
              {{row[i] || ' '}}
            </td>
          </tr>
        </tbody>
      </table>
     </div>

   </div>


</div>
</div>
<!-- <div mat-dialog-actions>
  <button mat-button >No Thanks</button>
  <button mat-button  cdkFocusInitial>Ok</button>
</div> -->
